import { TBColumn } from '../../interfaces/TableBits.interfaces';
const columns: TBColumn[] = [
    {
        id: "Fecha",
        label: 'Fecha',
        align: 'left',
    },
    {
        id: "Titulo",
        label: 'Título',
        align: 'left',
    },
    {
        id: "Descripcion",
        label: 'Descripción',
        align: 'left',
    },
    {
        id: "projects",
        label: 'Proyecto',
        align: 'left',
    },
];

export default columns;